var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconDeleteRow = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-0.858 -0.583)" },
                React.createElement("path", { d: "M8.4,10.6h15" }),
                React.createElement("path", { d: "M21.7,10.6v11.7c0,0.9-0.7,1.7-1.7,1.7h-8.3c-0.9,0-1.7-0.7-1.7-1.7V10.6 M12.5,10.6V8.9\n\t\tc0-0.9,0.7-1.7,1.7-1.7h3.3c0.9,0,1.7,0.7,1.7,1.7v1.7" })),
            React.createElement("path", { d: "M21.8,15H30" }),
            React.createElement("path", { d: "M0,15h8.2" }))));
});
export default IconDeleteRow;
//# sourceMappingURL=IconDeleteRow.js.map